<template>
    <div class='component-page'>
        <!--文本搜索位置-->
        <div class="filter-area">
            <Row style='text-align: center;' class='add_search'>
                <Col span='2'>
                    <span @click='uerType(1)' class='type-list' :class="type==1?'active':''">平台日报</span>
                </Col>
                <Col span='2'>
                    <span @click='uerType(2)' class='type-list' :class="type==2?'active':''">代理日报</span>
                </Col>
               
            </Row>
        </div>
        <!--下拉搜索位置-->
        <div class="edittable-table-height-con">
            <Row class='search-select'>
                <Col span="8">
                    <span>时间：</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='start_time' style="width: 130px;display:inline-block" @on-change='changStarttime'></Date-picker>
                    <span style="margin: 0 10px;">至</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='end_time' style="width: 130px;display:inline-block" @on-change='changEndtime'></Date-picker>
                </Col>
                <Col span='4' v-if='type==2'>
                    <Select v-model="formItem.proxy_id" placeholder="代理" @on-change="handleSearch" clearable style="width:200px">
                        <Option v-for="item in proxyList" :value="item.proxy_id" :key="item.proxy_id">{{ item.proxy_name }}</Option>
                    </Select>
                </Col>
            </Row>
            <Table stripe border :columns="platformColumns" :data="platformData" v-if='type==1'></Table>
            <Table stripe border :columns="agentColumns" :data="agentData" v-if='type==2'></Table>

            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right'  size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
        </div>
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>
<style>
    .school {
        float: left;
        font-size: 14px;
        line-height: 30px;
        margin-right: 10px;
        cursor: pointer;
        padding: 0 10px;
    }
    
    .school.active {
        background: #ddd;
    }
    
    .active {
        border-bottom: 2px solid #000;
        padding-bottom: 10px;
    }
    
    .type-list {
        cursor: pointer;
    }
</style>
<script>
    import {
        fetchTableList,
        fetchAgentList,
      
    } from '@/api/chargesSatistics'
    import {
        fetchProxyList,
      
    } from '@/api/common'

    
    export default {
        name: 'user-components',
        data () {
            return {
                total_count: 0, //列表总条数
                formItem:{
                    page: 1, //列表当前页数
                    page_size: 10,
                    proxy_id: '', 
                    start_time: '',
                    end_time: '',
                },
                start_time: '',
                end_time: '',
                type:1,
                platformColumns: [
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                
                    {
                        title: '订单数量',
                        align: 'center',
                        key: 'order_num',

                    },
                    {
                        title: '总订单金额',
                        align: 'center',
                        key: 'order_sum',
                    },
                  
                    {
                        title: '新增代理',
                        align: 'center',
                        key: 'proxy_num',
                      
                    },
                    {
                        title: '新增校区',
                        align: 'center',
                        key: 'school_num',
                      
                    },
                    {
                        title: '新增老师',
                        align: 'center',
                        key: 'teacher_num',
                    },
                    {
                        title: '新增学生',
                        align: 'center',
                        key: 'user_num',
                    },
                   
                ],//列表
                agentColumns:[
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                
                    {
                        title: '代理人',
                        align: 'center',
                        key: 'proxy_name',
                    },
                    {
                        title: '新增学校',
                        align: 'center',
                        key: 'school_num',
                    },
                    {
                        title: '新增学生',
                        align: 'center',
                        key: 'user_num',
                    },
                   
                ],
                platformData: [],//列表数据
                agentData: [],//列表数据
            };
        },
        methods: {
            //获取列表数据
            getData () {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res=res.data;
                    this.$Loading.finish();
                    if(res.code == 200){
                        this.platformData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            getAgentData(){
                this.$Loading.start();
                fetchAgentList(this.formItem).then(res => {
                    res=res.data;
                    this.$Loading.finish();
                    if(res.code == 200){
                        this.agentData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            getProxyList(){
                fetchProxyList().then(res => {
                    res=res.data;
                    if(res.code == 200){
                        this.proxyList = res.data;
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            uerType(type) {
                this.type = type;
                this.formItem.page = 1;
                if(type==1){
                    this.getData();
                }else{
                    this.getAgentData();
                }
                
            },
             // 改变开始时间
            changStarttime(time) {
                if (time == '') {
                    this.formItem.start_time = '';
    
                } else {
                    this.formItem.start_time = new Date(time).getTime() / 1000 - 28800;
                }
                this.formItem.page = 1;
                if(this.type==1){
                    this.getData();

                }else{
                    this.getAgentData();

                }
            },
            // 改变结束时间
            changEndtime(time) {
                if (time == '') {
                    this.formItem.end_time = '';
    
                } else {
                    this.formItem.end_time = new Date(time).getTime() / 1000 + 57600;
                }
                this.formItem.page = 1;
                if(this.type==1){
                    this.getData();

                }else{
                    this.getAgentData();

                }
            },
            // 取消关闭弹层
            cancel(){
                this.addModel=false;
                this.detailsModal=false;
            },
           
            //搜索框搜索
            handleSearch () {
                this.formItem.page = 1;
                if(this.type==1){
                    this.getData();

                }else{
                    this.getAgentData();

                }
            },
            //改变当前页码
            changePage (row) {
                this.formItem.page = row;
                if(this.type==1){
                    this.getData();

                }else{
                    this.getAgentData();

                }
            },
            
        },
        created () {
            this.getData();
            this.getProxyList();
        }
    };
</script>
